import { getWawechratData } from "api/graphQL_dashboard";
import LineChart from "components/charts/LineChart";
import DivLoader from "components/divloader/DivLoader";
import { useEffect, useState, useContext } from "react";
import { lineChartOptionsTotalSpent as lineChartOptionsTotalSpentinit } from "variables/charts";
import { ClientContext } from "ClientProvider";

const TotalSpent = ({
  datesTop, timeFrameTop, selectOrg, selectClient, selectCard,
}: {
  type?: string; datesTop?: any; timeFrameTop?: any;
  selectOrg?: any; selectClient?: any; selectCard?: any;
}) => {
  const [chartData, setChartData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [lineChartData, setLineChartData] = useState<any[]>();
  const [lineChartOptions, setLineChartOptions] = useState<any>();
  const { dashboardData } = useContext(ClientContext);
  const [dates, setDates] = useState<[Date, Date]>(datesTop);
  const [timeFrame, setTimeFrame] = useState<string>(timeFrameTop);

  const getInitialDates = () => {
    const now = new Date();
    const back = new Date(now);
    back.setMonth(back.getMonth() - 3);
    setDates([back, now]);
  };

  const fetchPayments = () => {
    setIsLoading(true);
    let dataP: any = {
      time_frame: timeFrame,
      org_ids: selectOrg?.length > 0 ? selectOrg?.map((m: any) => m?.id)?.toString() : "",
      client_ids: selectClient?.length > 0 ? selectClient?.map((m: any) => m?.id)?.toString() : "",
      card_type: selectCard?.length > 0 ? selectCard?.map((m: any) => m?.value)?.toString() : "",
    };
    if (dates) { dataP = { ...dataP, start_date: dates[0].toISOString().substring(0, 10), end_date: dates[1].toISOString().substring(0, 10) }; }
    if (timeFrame !== "custom") { delete dataP.start_date; delete dataP.end_date; }

    let xAxis: any[] = [];
    getWawechratData(dataP, dashboardData)
      .then((data) => {
        setChartData(data);
        setLineChartData(() => {
          const arr = Object.entries(data).map(([key, value]: any) => {
            if (key === "APPROVED" || key === "DECLINED") {
              const modified = Object.entries(value).map(([k, v]: any) => {
                const parts = k.split("-");
                const month = data?.grouped_by === "day" ? parts[0] : parts[1];
                const name = new Date(2000, month - 1).toLocaleString("default", { month: "short" });
                return { month: [name + "-" + (data?.grouped_by === "day" ? parts[1] : parts[0])], value: v };
              });
              xAxis = modified.map((e) => e.month);
              return { name: key, data: modified.map((e) => e.value), color: key === "APPROVED" ? "#16a34a" : "#ef4444" };
            }
            return null;
          });
          return arr.filter(Boolean);
        });
        setLineChartOptions({ ...lineChartOptionsTotalSpentinit, xaxis: { ...lineChartOptionsTotalSpentinit.xaxis, categories: xAxis } });
      })
      .catch(() => {}).finally(() => setIsLoading(false));
  };

  useEffect(() => { getInitialDates(); }, []);
  useEffect(() => { const t = setTimeout(fetchPayments, 1000); return () => clearTimeout(t); }, [dashboardData, dates, timeFrame, selectOrg, selectClient, selectCard]);
  useEffect(() => { setDates(datesTop); setTimeFrame(timeFrameTop); }, [datesTop, timeFrameTop]);

  const hasData = chartData?.total_transactions > 0;

  const STATS = [
    { label: "Total", value: chartData?.total_transactions, type : "blue" },
    { label: "Approved", value: chartData?.transactions_approved, type : "green" },
    { label: "Declined", value: chartData?.transactions_declined, type : "red" },
  ];

  const STATS_SECOND = [
    { label: "Total",    value: chartData?.total_transactions,   color: "#1d4ed8", bg: "#eff6ff", border: "#bfdbfe" },
    { label: "Approved", value: chartData?.transactions_approved, color: "#15803d", bg: "#f0fdf4", border: "#bbf7d0" },
    { label: "Declined", value: chartData?.transactions_declined, color: "#dc2626", bg: "#fff7f7", border: "#fecaca" },
  ];

  return (
    <div className="ts-card">
      {/* ── Header ── */}
      <div className="ts-header">
        <div className="ts-header-left">
          <div className="ts-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
            </svg>
          </div>
          <div>
            <h3 className="ts-title">Transaction Trends</h3>
            <p className="ts-subtitle">Approved vs declined over time</p>
          </div>
        </div>
        <div className="ts-header-right">
          {STATS.map((s) => (
            <div className={`adp-total-badge${s.type === 'red' ? " adp-total-badge--red" : s.type === "blue" ? " adp-total-badge--blue" :  " adp-total-badge--green"}`}>
              {s.value?.toLocaleString()} {s.label}
            </div>
          ))}
        </div>
      </div>

      {/* ── Stat chips ── */}
      {/* {hasData && (
        <div className="ts-stats-row">
          {STATS_SECOND.map((s) => (
            <div key={s.label} className="ts-stat-chip" style={{ background: s.bg, borderColor: s.border }}>
              <span className="ts-stat-chip-label">{s.label}</span>
              <span className="ts-stat-chip-value" style={{ color: s.color }}>{s.value?.toLocaleString()}</span>
            </div>
          ))}
        </div>
      )} */}

      

      {/* ── Chart ── */}
      <div className="ts-body">
        {isLoading ? (
          <div className="ts-center">
            <div className="ts-spinner" />
            <p className="ts-hint">Loading chart data…</p>
          </div>
        ) : lineChartOptions && lineChartData && hasData ? (
          <div className="ts-chart-wrap">
            <LineChart chartOptions={lineChartOptions} chartData={lineChartData} />
          </div>
        ) : (
          <div className="ts-center">
            <div className="ts-empty-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
              </svg>
            </div>
            <p className="ts-empty-title">No transaction data</p>
            <p className="ts-hint">Try selecting a different time frame or date range</p>
          </div>
        )}
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .ts-card {
          font-family: 'Plus Jakarta Sans', sans-serif;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(15,23,42,0.06);
          display: flex; flex-direction: column;
        }

        .adp-total-badge { font-size: 12px; font-weight: 700; padding: 5px 12px; border-radius: 100px; }
        .adp-total-badge--green { background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0; }
        .adp-total-badge--red   { background: #fff7f7; color: #dc2626; border: 1px solid #fecaca; }
        .adp-total-badge--blue   { background: #fff7f7; color: #1d4ed8; border: 1px solid #bfdbfe; }

        /* Header */
        .ts-header {
          padding: 22px 24px 16px;
          border-bottom: 1px solid #f1f5f9;
          display: flex; align-items: center; justify-content: space-between; gap: 12px;
        }
        .ts-header-left { display: flex; align-items: center; gap: 12px; }
        .ts-header-right {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }
        .ts-icon {
          width: 40px; height: 40px; border-radius: 11px;
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          border: 1.5px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center;
          color: #2563eb; flex-shrink: 0;
        }
        .ts-title { font-size: 15px; font-weight: 700; color: #0f172a; letter-spacing: -0.2px; margin-bottom: 2px;line-height:22px }
        .ts-subtitle { font-size: 12px; color: #94a3b8; font-weight: 500; }

        /* Stat chips */
        .ts-stats-row {
          display: flex; gap: 10px; padding: 16px 24px 0;
          flex-wrap: wrap;
        }
        .ts-stat-chip {
          display: flex; flex-direction: column;
          padding: 10px 16px; border-radius: 12px; border: 1.5px solid;
          min-width: 90px;
        }
        .ts-stat-chip-label { font-size: 11px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 4px; }
        .ts-stat-chip-value { font-size: 20px; font-weight: 800; letter-spacing: -0.5px; line-height: 1.1; }

        /* Legend */
        .ts-legend {
          display: flex; gap: 16px; padding: 12px 24px 0; flex-wrap: wrap;
        }
        .ts-legend-item { display: flex; align-items: center; gap: 7px; font-size: 12.5px; font-weight: 600; color: #475569; }
        .ts-legend-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }

        /* Body */
        .ts-body { flex: 1; padding: 16px 12px 16px; }
        .ts-chart-wrap { height: 300px; }
        .ts-center {
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          height: 260px; gap: 10px;
        }
        .ts-empty-icon {
          width: 56px; height: 56px; border-radius: 14px;
          background: #f8fafc; border: 1.5px solid #e2e8f0;
          display: flex; align-items: center; justify-content: center;
          color: #cbd5e1;
        }
        .ts-empty-title { font-size: 14px; font-weight: 700; color: #64748b; }
        .ts-hint { font-size: 12.5px; color: #94a3b8; font-weight: 500; text-align: center; max-width: 240px; }
        .ts-spinner {
          width: 28px; height: 28px;
          border: 3px solid #e2e8f0; border-top-color: #2563eb;
          border-radius: 50%; animation: tsSpin 0.7s linear infinite;
        }
        @keyframes tsSpin { to { transform: rotate(360deg); } }

        @media (max-width: 600px) {
          .ts-stats-row { gap: 8px; }
          .ts-stat-chip { min-width: 80px; padding: 8px 12px; }
          .ts-stat-chip-value { font-size: 17px; }
        }
      `}</style>
    </div>
  );
};

export default TotalSpent;